import videojs from 'video.js';
import './overflow-menu-item.css';

const MenuItem = videojs.getComponent('MenuItem');
let localize;

const _callback = new WeakMap();
export class OverflowMenuItem extends MenuItem {
    constructor(player, options) {
        localize = player.localize?.bind(player);
        super(player, options);
        _callback.set(this, options.callback);

        const { icon } = options;
        if (icon) {
            this.el().style.backgroundImage = `url("${icon}")`;
        }

        if (options.dismissable) {
            this.addClass('mediasite-player__controlbar-dismissable-item');
            const theButton = this.el().appendChild(document.createElement('button'));
            theButton.type = 'button';
            theButton.setAttribute('aria-label', localize('Dismiss notification'));
        }
    }

    handleClick(event) {
        let type = 'invoke';
        if (this.options().dismissable && event.target.tagName.toLowerCase() === 'button') {
            type = 'dismiss';
        }
        _callback.get(this)({ type });
    }
}
